"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "changeVolume", {
  enumerable: true,
  get: function get() {
    return _changeVolume["default"];
  }
});
Object.defineProperty(exports, "togglePlay", {
  enumerable: true,
  get: function get() {
    return _togglePlay["default"];
  }
});
var _togglePlay = _interopRequireDefault(require("./togglePlay"));
var _changeVolume = _interopRequireDefault(require("./changeVolume"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }